module.exports = __webpack_public_path__ + "static/media/cta button.081f22ef.png";